module.exports = __webpack_public_path__ + "img/use-voip.31a8dfd0.svg";